// extracted by mini-css-extract-plugin
export default {"search":"search__Z5GDo","addPhone":"addPhone__rqubc","addIcon":"addIcon__KQhIl","addButtonText":"addButtonText__Py00M","contacts":"contacts__FK91R"};